module.exports = __webpack_public_path__ + "assets/img/642337a934ca61e5a94aff134b4d009b.svg";